module.exports = __webpack_public_path__ + "img/icon-computer.7d90c24.png";